<template>
  <div class="new">
    <progressBar
      class="new-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <div class="new-product" v-if="progressActiveIndex === 0">
      <div class="new-top">
        <div class="new-top__name">选择计划储备的产品</div>
        <div class="new-top__fun">
          <el-select size="mini" placeholder="全部国家" :style="{width: getScaleByUI('100px')}"></el-select>
          <el-select size="mini" placeholder="全部店铺" :style="{width: getScaleByUI('100px')}"></el-select>
          <el-input size="mini" placeholder="可输入产品名称,型号,店铺名称等" :style="{width: getScaleByUI('200px')}"></el-input>
          <div class="new__btn">查询</div>
        </div>
      </div>
      <div class="new-table">
        <Table :head="productTableHead" :body="productList" @clickCheck="changeProductCheck" width="1096" height="300"></Table>
      </div>
    </div>
    <div class="new-num" v-if="progressActiveIndex === 1">
      <div class="new-top">
        <div class="new-top__name">输入产品计划储备数量及交货日期</div>
      </div>
      <div class="new-table">
        <Table
          :head="reservesNumTableHead"
          :body="reservesNumTableBody"
          @changeInput="inputReservesNum"
          height="300"></Table>
      </div>
    </div>
    <div class="new-bottom">
      <div class="new-bottom-left">
        <template v-if="progressActiveIndex === 1">
          <div class="new-bottom-item">
            <div class="new-bottom-item__name">计划交货日期</div>
            <el-date-picker size="mini" v-model="plannedDeliveryDate" placeholder="选择日期时间"></el-date-picker>
          </div>
        </template>
      </div>
      <div class="new-bottom-right">
        <template v-if="progressActiveIndex != 0">
          <div class="new__btn" @click="preStep">上一步</div>
        </template>
        <template v-if="isSurplusStock">
          <div class="new__btn" @click="openTrunkDialog">新建尾箱</div>
        </template>
        <template v-if="progressActiveIndex != progressData.length - 1">
          <div class="new__btn" @click="nextStep">
            <template v-if="progressActiveIndex === 1">
              生成产品储备计划单
            </template>
            <template v-else>
              下一步
            </template>
          </div>
        </template>
      </div>
    </div>
    <Dialog :show="trunkDialogShow" @cancel="cancelTrunkDialog">
      <div class="new-dialog">
        <div class="new-dialog-top">
          <div class="new-dialog__title">新建尾箱</div>
          <div class="new-dialog__subtitle">(注意: "外箱尺寸不同","箱内装不同型号产品" 或 "箱内装相同型号产品但数量不同" 都看作"不同箱型的外箱",必须点击"新建尾箱"分别创建才能保证数据准确!)</div>
        </div>
        <div class="new-dialog-table">
          <Table :head="trunkTableHead" height="200" lineHeight="40"></Table>
        </div>
        <div class="new-dialog-info">
          <div class="new-dialog-info__title">尾箱详细信息:</div>
          <div class="new-dialog-info-data">
            <div class="new-dialog__star">*</div>
            <div class="new-dialog-info__text">箱型：外箱尺寸：</div>
            <div class="new-dialog-info__size">
              <el-input placeholder="长(cm)" size="mini"></el-input>
              <el-input placeholder="宽(cm)" size="mini"></el-input>
              <el-input placeholder="高(cm)" size="mini"></el-input>
            </div>
            <div class="new-dialog-info__unit">(cm)</div>
            <div class="new-dialog__star">*</div>
            <div class="new-dialog-info__text">外箱重量：</div>
            <el-input placeholder="" size="mini"></el-input>
            <div class="new-dialog-info__unit">(kg)</div>
            <div class="new-dialog__star">*</div>
            <div class="new-dialog-info__text">箱数：</div>
            <el-input placeholder="" size="mini"></el-input>
            <div class="new-dialog-info__unit">(箱)</div>
          </div>
          <div class="new-dialog-info__tip">(提示: 在现实场景下, 1. 通常先将尾货装入外箱(如外箱过大可裁切缩小外箱尺寸)；2. 然后再确认箱内产品的型号及数量；3. 然后实量外箱尺寸，实称外箱重量，确认同样尺寸同样装箱内容的外箱数量；4. 然后将确认的数据输入上面的单元格中；5. 点击“新建尾箱”,新建的尾箱信息将保存到“新建亚马逊进仓计划单”内; 6. 同理,如果还有尾货则需要继续重复该流程；)</div>
        </div>
        <div class="new-dialog-bottom">
          <div class="new-dialog__btn" @click="cancelTrunkDialog">新建尾箱</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { ProductReservestNewModule, ProductList, ProductReservest } from './class'
import { DealResult } from 'common/dataClass/Default'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import Dialog from 'components/common/Dialog'
import globalData from 'common/globalData';
import ProductAxios from 'service/product'
export default {
  name: 'newProductReserves',
  components: {
    progressBar, Table, Dialog
  },
  data(){
    return {
      /**进度条数据 */
      progressData: ProductReservestNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 0,
      /**计划交货日期 */
      plannedDeliveryDate: '',
      /**产品 */
      productTableHead: ProductReservestNewModule.NEWPRODUCTTABLEHEAD(),
      productList: [],
      /**产品储备装箱情况表头 */
      reservesNumTableHead: ProductReservestNewModule.NEWNUMTABLEHEAD(),
      reservesNumTableBody: [],
      /**尾箱弹窗 */
      trunkDialogShow: false,
      trunkTableHead: ProductReservestNewModule.NEWTRUNKTABLEHEAD()
    }
  },
  methods: {
    getScaleByUI: globalData.getScaleByUI,
    /**上一步 */
    preStep(){
      this.progressActiveIndex --
    },
    /**下一步 */
    nextStep(){
      let func = {
        0: () => {
          let reservesListTmp = this.productList.filter(item => item.check)
          if(reservesListTmp.length === 0){
            return new DealResult(1002, '至少选择一个商品')
          }else{
            this.reservesNumTableBody.splice(0, this.reservesNumTableBody.length)
            reservesListTmp.map(item => {
              let obj = new ProductReservest(true)
              obj.importParentData(item)
              this.reservesNumTableBody.push(obj)
            })
            return new DealResult(1, '下一步')
          }
        }
      }
      let res = func[this.progressActiveIndex]()
      if(res.code === 1){
        this.progressActiveIndex ++
      }else{
        this.$message.error(res.info)
      }
    },
    /**获取产品列表 */
    async getProductList(){
      let obj = {export: null, productType: null, text: null}
      let res = await ProductAxios.productList(obj)
      if(res.data.code === 1){
        this.productList.splice(0, this.productList.length)
        let array = res.data.info
        array.map(obj => {
          let productTmp = new ProductList()
          productTmp.backendListDataParsing(obj)
          productTmp.check = false
          this.productList.push(productTmp)
        })
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**产品多选框点击事件 */
    changeProductCheck(index){
      this.productList[index].check = !this.productList[index].check
    },
    /**计划储备数量输入事件 */
    inputReservesNum(value, index, key){
      this.reservesNumTableBody[index][key] = value
      this.reservesNumTableBody[index].numByBox = Math.floor(value / this.reservesNumTableBody[index].boxNum)
      this.reservesNumTableBody[index].numInBox = this.reservesNumTableBody[index].numByBox * this.reservesNumTableBody[index].boxNum
      this.reservesNumTableBody[index].numByLast = value % this.reservesNumTableBody[index].boxNum
      if(this.reservesNumTableBody[index].numByBox == this.reservesNumTableBody[index].numInBox
        && this.reservesNumTableBody[index].numInBox == this.reservesNumTableBody[index].numByLast){
        this.reservesNumTableBody[index].boxStatus = -1
      }
    },
    /**关闭尾箱弹窗 */
    cancelTrunkDialog(){
      this.trunkDialogShow = false
    },
    /**打开尾箱弹窗 */
    openTrunkDialog(){
      this.trunkDialogShow = true
    }
  },
  created(){
    this.getProductList()
  },
  computed:{
    /**是否存在尾货 */
    isSurplusStock(){
      return this.reservesNumTableBody.some(item => item.boxStatus === 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1200px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    &__name{
      font-weight: bold;
      font-size: 14px;
      color: black;
    }
    &__fun{
      display: flex;
      align-items: center;
      ::v-deep{
        .el-select{
          margin-right: 10px;
        }
      }
    }
  }
  &-bottom{
    display: flex;
    justify-content: space-between;
    &-left{
      display: flex;
    }
    &-right{
      display: flex;
      align-items: end;
    }
    &-item{
      text-align: center;
      margin: 0 5px;
      width: 180px;
      &__name{
        font-weight: bold;
        margin: 2px 0;
      }
      ::v-deep{
        .el-input{
          width: 180px;
        }
        .el-input__inner{
          width: 180px;
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &__btn{
    line-height: 30px;
    padding: 0 15px;
    color: white;
    background: #00a0c7;
    margin-left: 10px;
    &:hover{
      cursor: pointer;
      opacity: .8;
    }
  }
  &-dialog{
    &-top{
      display: flex;
      align-items: end;
    }
    &__title{
      color: black;
      font-weight: bold;
      font-size: 16px;
    }
    &__subtitle{
      color: #fca605;
      font-size: 12px;
    }
    &__star{
      color: red;
      font-weight: bold;
      font-size: 12px;
    }
    &-info{
      ::v-deep{
        .el-input{
          width: 100px;
        }
        .el-input__inner{
          width: 100px;
        }
      }
      &__title{
        color: #00a0c7;
        font-weight: bold;
        font-size: 14px;
      }
      &-data{
        display: flex;
        align-items: center;
        margin: 5px 0;
      }
      &__text{
        font-size: 14px;
      }
      &__size{
        ::v-deep{
          .el-input{
            width: 80px;
            margin-right: 4px;
          }
          .el-input__inner{
            width: 80px;
          }
        }
      }
      &__unit{
        margin: 0 8px 0 2px;
      }
      &__tip{
        color: #fca605;
      }
    }
    &-bottom{
      display: flex;
      justify-content: end;
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
